// src/pages/common/COM301F1.jsx
import React, {useEffect, useState} from 'react';

import DataGrid from "components/DataGrid/DataGrid"

import cdmInfoData from "assets/json/frmFront_loadData.json"

import style from './MSA101F1.module.scss'

const MSA101F1 = ({navBar: NavBar}) => {
    //공지사항
    const [rows_Notice, setRows_Notice] = useState([]);
    const cols_Notice = [
        { key: 'ntceId',        name: 'NO',      width: '10%', sortable:'true' },
        { key: 'titlNm',        name: '제목',     width: '55%', cellClass: 'align_left' },
        { key: 'ntceDvsnCdNm',  name: '구분',     width: '15%'},
        { key: 'frstRgstDt',    name: '작성일',   width: '20%'}
    ];

    //QnA
    const [rows_Qna, setRows_Qna] = useState([]);
    const cols_Qna = [
        { key: 'qstnRespId',     name: 'NO',      width: '10%', sortable:'true' },
        { key: 'titlNm',         name: '제목',     width: '55%', cellClass: 'align_left' },
        { key: 'qstnRespCtryNm', name: '카테고리',  width: '15%'},
        { key: 'frstRgstDt',     name: '작성일',   width: '20%'}
    ];

    //CDM 최종반영일
    const [rows_CdmLastRef, setRows_CdmLastRef] = useState([]);
    const cols_CdmLastRef = [
        { key: 'hsptNm',      name: '시스템명(기관명)', width: '50%', sortable:'true' },
        { key: 'collPrid',    name: '데이터 수집기간',  width: '30%'},
        { key: 'lastUpdtDt',  name: '최종반영일',      width: '20%'}
    ];

    //CDM ETL 카운트
    const [rows_CdmETLCtn, setRows_CdmETLCtn] = useState([]);
    const cols_CdmETLCtn = [
        { key: 'cdmItem',  name: 'CDM 항목',  width: '40%', sortable:'true' },
        { key: 'aaCnt',    name: '안암병원',   width: '20%', cellClass: 'align_right' },
        { key: 'grCnt',    name: '구로병원',   width: '20%', cellClass: 'align_right'},
        { key: 'asCnt',    name: '안산병원',   width: '20%', cellClass: 'align_right'}
    ];

    //코드 매핑 카운트
    const [rows_CodeMapCnt, setRows_CodeMapCnt] = useState([]);
    const cols_CodeMapCnt = [
        { key: 'bswrClsfNm',  name: '분류명',   width: '40%', sortable:'true' },
        { key: 'mapCnt',      name: '매핑',     width: '20%', cellClass: 'align_left' },
        { key: 'noMapCnt',    name: '미매핑',   width: '20%'},
        { key: 'mapPer',      name: '매핑률',   width: '20%'}
    ];


    useEffect(() => {

        setRows_CdmLastRef(cdmInfoData.CdmLastRefInfo);
        setRows_CdmETLCtn(cdmInfoData.CdmETLCtn);
        setRows_CodeMapCnt(cdmInfoData.CodeMapCnt);
    }, []);

    return(
        <main className={style.main_wrap}>
            <NavBar>
                {/*Nav 내용*/}
            </NavBar>
            <div className={style.dashBox}>
                <div className={style.dashItem}>
                    <h6 className={style.dashItem__title}>CDM 최종반영일</h6>
                    <div className={style.dashItem__content}>
                        <DataGrid
                            cols={cols_CdmLastRef}
                            rows={rows_CdmLastRef}
                            size='md'
                            headerRowHeight={30}
                            rowHeight={30}
                            isRowColorful = {false}
                        />
                    </div>
                </div>
                <div className={style.dashItem}>
                    <h6 className={style.dashItem__title}>CDM ETL 카운트</h6>
                    <div className={style.dashItem__content}>
                        <DataGrid
                            cols={cols_CdmETLCtn}
                            rows={rows_CdmETLCtn}
                            size='md'
                            headerRowHeight={30}
                            rowHeight={30}
                            isRowColorful = {false}
                        />
                    </div>
                </div>
                <div className={style.dashItem}>
                    <h6 className={style.dashItem__title}>코드 매핑 카운트</h6>
                    <div className={style.dashItem__content}>
                        <DataGrid
                            cols={cols_CodeMapCnt}
                            rows={rows_CodeMapCnt}
                            size='md'
                            headerRowHeight={30}
                            rowHeight={30}
                            isRowColorful = {false}
                        />
                    </div>
                </div>
            </div>
        </main>
    )
}
export default MSA101F1;
